<template>
  <div v-if="answer.scores">
    <div class="clearfix">
      <div class="page-title float-left">
        <mdb-badge>수행평가 채점</mdb-badge>
        {{test.subject}}
        <span v-if="test.subject != test.name"> / {{test.name}} </span>
      </div>
      <div class="float-right">
        <mdb-btn icon="undo" class="p-2" @click="$router.back()">목록</mdb-btn>
        <mdb-btn class="p-2" icon="save" color="primary" @click="onSave">저장</mdb-btn>
      </div>
    </div>
    <div class="clearfix">
      <div class="float-left bolder" :class="{'red-text': answer.score < failScore }">점수 : {{answer.score}} 점</div>
      <div class="float-right">제출일: <mdb-icon icon="clock" class="ml-4" /> {{$strDate(answer.regDate)}}</div>
    </div>
    <div>

      <!-- <a :href="`/api/download/${answer.training}/perform/${answer.file}/${answer.orgFile}?seq=${answer.seq}`" target="_blank"> -->
        <save-btn-sm @click="onDownload">파일 다운로드</save-btn-sm>
      <!-- </a> -->
    </div>
    <mdb-tbl sm>
      <mdb-tbl-head>
        <tr class="title bolder">
          <th class="bolder">평가항목</th>
          <th class="bolder w-10 text-center" >점수</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body v-for="(u, ux) in test.units" :key="u._id">
          <tr>
            <td colspan="2" class="bolder blue lighten-5">
              {{u.name}} <span v-if="u.name !== u.code">{{u.code}}</span>
            </td>
          </tr>
          <tr v-for="(c, cx) in u.content" :key="c._id">
            <td>{{c}}</td>
            <td class="text-center" >
              <select class="select-underline" v-model="answer.scores[ux][cx]" @change="onChange">
                <option>하</option>
                <option>중</option>
                <option>상</option>
              </select>
            </td>
          </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <div></div>
    <div></div>
    <div class="my-3 underline title"><mdb-icon far icon="comment-alt" /> 강사의견</div>
    <mdb-input type="textarea" :rows="5" v-model="answer.comment"/>
    <div class="text-right">
      <mdb-btn icon="undo" class="p-2" @click="$router.back()">목록</mdb-btn>
      <mdb-btn class="p-2" icon="save" color="primary" @click="onSave">저장</mdb-btn>
    </div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PerformTest from '@/models/test/PerformTest'
import PerformTestAnswer from '@/models/test/PerformTestAnswer'
export default {
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  name: 'StaffPerformTestView',
  computed: {
    ...mapGetters('training', ['failScore'])
  },
  data: () => ({
    test: {},
    answer: {}
  }),
  methods: {
    async load () {
      const { test, answer } = this.$route.query
      this.test = await PerformTest.get(test)
      this.answer = await PerformTestAnswer.get(answer)
      // 최초 채점이면 answers.scores가 비어 있음.... 이를 만들어줘야 함.
      // console.log('수행 채점', this.answer.scores)
      if (this.answer.scores.length === 0) {
        this.answer.score = 100
        this.test.units.forEach((u, ux) => {
          this.answer.scores[ux] = []
          // u.content 만큼 객체 배정
          for (let i = 0; i < u.content.length; i++) {
            this.answer.scores[ux][i] = '상'
          }
        })
        // this.answer = await this.answer.save()
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.answer = await this.answer.save()
    },
    // 항목 채점시 마다 바로 바로 채점
    onChange () {
      this.answer.score = this.answer.mark()
    },
    onDownload () {
      const url = `/api/download/${this.answer.training}/perform/${this.answer.file}/${this.answer.orgFile}?seq=${this.answer.seq}`
      this.$download(url, this.answer.orgFile)
    }
  },
  created () {
    this.load()
  },
  watch: {}
}
</script>
